import { useForm, useInput } from "lx-react-form";
import React from "react";
import { Input } from "./Input";
import { BsWhatsapp, BsInstagram } from "react-icons/bs";
import { CgMail } from "react-icons/cg";
import {
  ButtonContainer,
  Container,
  ContentContainer,
  FormContainer,
  Label,
  LeftContainer,
  Paragraph,
  Social,
  SocialContainer,
  Title,
} from "./style";
import { Button } from "../Button";

export const ContactForm = () => {
  const nameInput = useInput({
    name: "name",
  });

  const emailInput = useInput({
    name: "email",
    validation: "email",
  });

  const empresaInput = useInput({
    name: "empresa",
  });

  const telefoneInput = useInput({
    name: "telefone",
    validation: "telefone",
    mask: "telefone",
    maxLength: 15,
  });

  const mensagemInput = useInput({
    name: "mensagem",
  });

  const form = useForm({
    clearFields: true,
    formFields: [
      nameInput,
      emailInput,
      empresaInput,
      telefoneInput,
      mensagemInput,
    ],
    submitCallback: (formData) => {
      console.log(formData);
    },
  });

  return (
    <Container>
      <Title>Contatos</Title>
      <ContentContainer>
        <LeftContainer>
          <Paragraph>
            Estou aguardando sua mensagem. Você pode mandar uma mensagem
            utilizando o formulário a seguir.
          </Paragraph>
          <SocialContainer>
            <Paragraph>
              Você também pode entrar em contato atraves das minhas redes
              sociais:
            </Paragraph>
            <Social>
              <a
                href="https://www.instagram.com/i.garciags/"
                target="_blank"
                rel="noreferrer"
              >
                <BsInstagram />
              </a>
              <a
                href="https://api.whatsapp.com/send?l=pt_BR&phone=55034991643423"
                target="_blank"
                rel="noreferrer"
              >
                <BsWhatsapp />
              </a>
              <a href="mailto:igorgg@gmail.com?subject=Olá, gostaria de entrar em contato com você!">
                <CgMail />
              </a>
            </Social>
          </SocialContainer>
        </LeftContainer>
        <FormContainer onSubmit={form.handleSubmit}>
          <Input
            label={"Nome"}
            placeholder={"Insira seu nome"}
            type={"text"}
            name={nameInput}
          />
          <Input
            label={"E-mail"}
            placeholder={"Insira seu email"}
            type={"email"}
            name={emailInput}
          />
          <Input
            label={"Empresa"}
            placeholder={"Insira o nome da sua Empresa"}
            type={"text"}
            name={empresaInput}
          />
          <Input
            label={"Telefone"}
            placeholder={"Insira seu telefone"}
            type={"text"}
            name={telefoneInput}
          />
          <Label>Mensagem</Label>
          <textarea
            label={"Mensagem"}
            placeholder={"Insira sua mensagem"}
            type={"text"}
            {...mensagemInput.inputProps}
          />
          <ButtonContainer>
            <Button type="submit">Enviar</Button>
          </ButtonContainer>
        </FormContainer>
      </ContentContainer>
    </Container>
  );
};
